module.exports = __webpack_public_path__ + "img/client-code.d334cc6a.png";